// Pure TS Layer: React 非依存
// Cognito Identity Pool / IoT Core 接続設定

export type IotAuthConfig = {
  readonly region: string;
  readonly identityPoolId: string;
  readonly iotEndpoint: string;
  readonly iotPolicyName: string;
};

export type IotAuthConfigResult =
  | { readonly ok: true; readonly value: IotAuthConfig }
  | { readonly ok: false; readonly missing: ReadonlyArray<string> };

/** Vite 環境変数から IotAuthConfig を読み込む。設定漏れがあれば missing で返す。 */
export function loadIotAuthConfig(): IotAuthConfigResult {
  const region = import.meta.env.VITE_AWS_REGION as string | undefined;
  const identityPoolId = import.meta.env.VITE_IDENTITY_POOL_ID as string | undefined;
  const iotEndpoint = import.meta.env.VITE_IOT_ENDPOINT as string | undefined;
  const iotPolicyName = import.meta.env.VITE_IOT_POLICY_NAME as string | undefined;

  const missing: string[] = [];
  if (!region) missing.push('VITE_AWS_REGION');
  if (!identityPoolId) missing.push('VITE_IDENTITY_POOL_ID');
  if (!iotEndpoint) missing.push('VITE_IOT_ENDPOINT');
  if (!iotPolicyName) missing.push('VITE_IOT_POLICY_NAME');

  if (missing.length > 0) {
    return { ok: false, missing };
  }
  return {
    ok: true,
    value: {
      region: region as string,
      identityPoolId: identityPoolId as string,
      iotEndpoint: iotEndpoint as string,
      iotPolicyName: iotPolicyName as string,
    },
  };
}
